import { inject, Injectable } from '@angular/core';
import { QueryEntity } from '@datorama/akita';
import { groupBy } from 'lodash-es';

import {
  PaymentSchedulesModel,
  PaymentSchedulesState,
  PaymentSchedulesStore,
} from './payment-schedules.store';

@Injectable({ providedIn: 'root' })
export class PaymentSchedulesQuery extends QueryEntity<PaymentSchedulesState> {
  protected store: PaymentSchedulesStore;

  constructor() {
    const store = inject(PaymentSchedulesStore);

    super(store);

    this.store = store;
  }

  getGroupedPaymentSchedules(): Record<string, PaymentSchedulesModel[]> {
    return groupBy(this.getAll(), 'patient_protocol_id');
  }
}
